// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CertificationsModuleLayout} from 'app_components/modules/certifications'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import {ICompanyUser} from 'app_types/admin/user/userTypes'
import { certificationsMock } from '../../../../mocks/certifications/certifications.mock';
// @end

// @ADD Component types
interface ICertificationsModuleProps {
  company?: ICompanyUser
}
interface ICertificationsModuleState {
  status: null | 'loading' | 'error'
  certificationsData: Array<any>
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CertificationsModule extends Component<ICertificationsModuleProps, ICertificationsModuleState> {

  private courseSchedulingEnrollmentService: CourseSchedulingEnrollmentService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICertificationsModuleProps) {
    super(props)
    this.state = {
      status: null,
      certificationsData: [],
      pagination: {
        page: 1,
        perPage: 30,
        total: 0,
      },
    }
    this.courseSchedulingEnrollmentService = new CourseSchedulingEnrollmentService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    // await this.fetchCertificationsData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchCertificationsData = async (params?: any) => {

    // TODO: Implementar filtros de fecha

    this.setState({
      status: 'loading',
      certificationsData: [],
    })

    const http_params: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      status: ['Complete'],
      certificate_clients: true
    }
    if (this.props.company?._id) {
      http_params['company'] = this.props.company?._id
    }
    if (params?.search) {
      http_params.search = params?.search
    }
    if (params?.searchDoc) {
      http_params.searchDoc = params?.searchDoc
    }

    let dataResponse = await this.courseSchedulingEnrollmentService.fetchCertificationsData(http_params, {showError: false})

    // @INFO Mock de certificados
    // @ts-ignore
    // dataResponse = {certifications: certificationsMock};

    if (dataResponse !== undefined && typeof dataResponse !== 'boolean') {
      let scheduling = []
      if (dataResponse.certifications) {
        scheduling = dataResponse.certifications.reduce((accum: Array<any>, element: any) => {
          accum.push(element)
          return accum
        }, [])
      }
      this.setState({
        certificationsData: scheduling,
        pagination: {
          total: dataResponse?.total_register,
          perPage: dataResponse?.nPerPage,
          page: dataResponse?.pageNumber,
        },
        status: null})
    } else {
      this.setState(({status: null}))
    }
  }

  onPageChange = async ({ page, search, searchDoc }: { page: number, search?: string, searchDoc?: string }) => {
    this.fetchCertificationsData({ page, search, searchDoc })
  }

  onSearch = async (event: any) => {
    this.fetchCertificationsData({ page: 1, search: event.search })
    return false
  }

  onSearchDoc = async (val: string) => {
    this.fetchCertificationsData({ page: 1, searchDoc: val })
    return false
  }

  render() {
    return(
      <CertificationsModuleLayout
        status={this.state.status}
        certificationsData={this.state.certificationsData}
        pagination={this.state.pagination}
        company={this.props.company}
        onPageChange={this.onPageChange}
        onSearch={this.onSearch}
        onSearchDoc={this.onSearchDoc}
      />
    )
  }
}

export default connect(mapStatesToProps)(CertificationsModule)
